// @ts-nocheck

import { TIMER_INCREMENT, TIMER_STOP } from '../constants/timer';
import PeriodIds from '../types/periodIds';
import { SportIds } from '../types/sports';

const getSoccerTimerType = (periodId) => {
  switch (periodId) {
    case PeriodIds.PERIOD_ID_FIRST_HALF:
    case PeriodIds.PERIOD_ID_SECOND_HALF:
    case PeriodIds.PERIOD_ID_SOCCER_OVERTME_FIRST_HALF:
    case PeriodIds.PERIOD_ID_SOCCER_OVERTME_SECOND_HALF:
    case PeriodIds.PERIOD_ID_PSO_START:
      return TIMER_INCREMENT;
    default:
      return TIMER_STOP;
  }
};

export const getType = (sportId, periodId) => {
  if (sportId === SportIds.SOCCER) {
    return getSoccerTimerType(periodId);
  }
  return TIMER_STOP;
};
